import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Pin } from 'lucide-react';

export function SellerShippingCard({
  contact,
  shippingLocationName,
  addressLine1,
  addressLine2,
  region,
  city,
  zipCode,
  isCoordinates = false,
  mapToggle,
}: {
  contact: string;
  shippingLocationName: string;
  addressLine1?: string | null;
  addressLine2?: string | undefined | null;
  region?: string | null;
  city?: string | null;
  zipCode?: string | null;
  isCoordinates?: boolean;
  mapToggle?: ReactNode;
}) {
  const cityStateZip = [city, region, zipCode].filter(Boolean).join(', ');
  const { t } = useTranslation('order');

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm">
      <div className="flex items-center gap-2 mb-4">
        <Pin size="18" className="text-prim" />
        <h2 className="text-neut-prim font-semibold">
          {t('order.shipping_address')}
        </h2>
      </div>
      <div className="space-y-2">
        <div>
          <p className="text-xs text-gray-500">{t('order.location')}</p>
          <p className="text-sm text-neut-prim font-medium">
            {shippingLocationName}
          </p>
        </div>
        <div>
          <p className="text-xs text-gray-500">{t('order.buyer_contact')}</p>
          <p className="text-sm text-neut-prim">{contact}</p>
        </div>
        <div>
          <p className="text-xs text-gray-500">
            {t(isCoordinates ? 'order.coordinates' : 'order.address')}
          </p>
          <p className="text-sm text-neutral-prim">{addressLine1}</p>
          {addressLine2 && (
            <p className="text-sm text-neutral-prim">{addressLine2}</p>
          )}
          {cityStateZip && (
            <p className="text-sm text-neutral-prim">{cityStateZip}</p>
          )}
          {mapToggle}
        </div>
      </div>
    </div>
  );
}
